
import { getLimitOptions } from 'utilities/query';
import templateUrl from './item-list.html';

export default {
  templateUrl,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    columns: '<',
    displayNamePlural: '@',
    query: '<',
    items: '<',
    selectedItems: '<',
    queryChanged: '&',
    searchTextChanged: '&'
  },
  controller: class ItemListComponent {
    constructor(EventEmitter) {
      'ngInject';

      Object.assign(this, { EventEmitter });

      this.onPaginationChanged = (page, take) => {
        this.onQueryChange({
          ...this.query,
          page,
          take
        });
      };

      this.onOrderChanged = (order) => {
        const direction = order.indexOf('-') !== -1 ? 'desc' : 'asc';
        const orderBy = order.replace('-', '');

        this.onQueryChange({
          ...this.query,
          direction,
          orderBy
        });
      };
    }

    $onInit() {
      this.limitOptions = getLimitOptions();
    }

    onQueryChange(query) {
      this.queryChanged(
        this.EventEmitter({
          query
        })
      );
    }

    onSearchTextChanged(searchText) {
      this.searchTextChanged(
        this.EventEmitter({
          searchText
        })
      );
    }

    get formattedDisplayName() {
      if (!this.displayName) {
        return 'Items';
      }

      return this.displayName;
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/common/item-list/item-list.component.js